import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form, Input, InputNumber, Select, DatePicker } from 'antd';
import FormItem from "components/fields/FormItem";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";
import { MONTH_OPTIONS, MODULE_INVOICES, DATE_FORMAT } from "variables/constants";
import { getClientList, getForexList } from "../../../../redux/optionlist/optionlistState";
import { doGenerateMonthlyInvoice } from "../../../../redux/invoice/invoiceState";

const MonthlyInvoiceForm = ({getClientOptions, getForexOptions, forexList, doGenerateInvoice, recordList = []}) => {
	
  	const [form] = useForm();
	const [clientDropdownOpen, setClientDropdownOpen] = useState(false);
  	
  	useEffect(() => {
        getClientOptions({asOptions: 1, for_invoice: 1});
	}, [getClientOptions]);

	useEffect(() => {
        getForexOptions({asOptions: 1});
	}, [getForexOptions]);

	const forexOptions = [
		{
			value: 0,
			label: "Manual",
		},
		...forexList,
	];

	const selectedClients = Form.useWatch('client_ids', form);

	const clientOptions = [
		{
			value: 'all',
			label: 'All Clients',
		},
		...(recordList || []).map(client => ({
			...client,
			disabled: selectedClients?.includes('all'),
		})),
	];

	const handleClientChange = (values) => {
		if (values.includes('all')) {
			form.setFieldsValue({
				client_ids: ['all'],
			});

    		setTimeout(() => setClientDropdownOpen(false), 0);
		}
		};
	
  	const onSubmit = (formData) => {	
    	try {  	
			const { inv_issue_date, inv_due_date, ...forSubmitValues } = formData;			  
			forSubmitValues.inv_issue_date = inv_issue_date ? inv_issue_date.format(DATE_FORMAT) : null;
			forSubmitValues.inv_due_date = inv_due_date ? inv_due_date.format(DATE_FORMAT) : null;
			doGenerateInvoice(forSubmitValues);
    	} catch (error) {
      		console.error('Generate failed:', error);
    	}
  	};

	const handleForexChange = (value) => {
		if(value === 0) {
			form.setFieldsValue({
				inv_forex_usd: null,
				inv_forex_aud: null,
			});
		}else{
			const selectedForex = forexList.find(forex => Number(forex.value) === Number(value));
			if(selectedForex) {
				form.setFieldsValue({
					inv_forex_usd: Number(selectedForex.usd),
					inv_forex_aud: Number(selectedForex.aud),
				});
			}
		}
	};

  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
				<h2 className="font-medium text-[18px] mb-4">Generate Client's Monthly Invoice</h2>
        		<div className="grid grid-cols-1 md:grid-cols-4 gap-4"> 
					<FormItem 
		            	name="month"
		                label="Month"
						rules={[requiredField()]}
		            >
		            	<Select 
							id="month"
							className="input-field"
		            		options={MONTH_OPTIONS}
		            	/>
	            	</FormItem>
					<FormItem 
		            	name="inv_forex_id"
		                label="Forex"
						rules={[requiredField()]}
		            >
		            	<Select 
							id="inv_forex_id"
							className="input-field"
		            		options={forexOptions}
							allowClear
							showSearch
							onChange={handleForexChange}
		            	/>
	            	</FormItem>
					<FormItem 
						name="inv_forex_usd"
						label="PHP to USD"
						hidden
					>
						<Input type="hidden" id="inv_forex_usd"/>
					</FormItem>
					<FormItem 
						name="inv_forex_aud"
						label="PHP to AUD"
						rules={[requiredField()]}
					>
						<InputNumber precision={4}
							id="inv_forex_aud"
							className="input-field aligned-right-number"
							style={{
								width: 150,
							}}
						/>
					</FormItem>
				</div>
				<div className="grid grid-cols-1 md:grid-cols-4 gap-4"> 
					<FormItem 
						label="Invoice Date"
						name="inv_issue_date"
						rules={[requiredField()]}
					>
						<DatePicker id="inv_issue_date"
							className="input-field"
							format={DATE_FORMAT}
							style={{ width: "100%" }}
						/>
					</FormItem>
					<FormItem 
						label="Due Date"
						name="inv_due_date"
						rules={[requiredField()]}
					>
						<DatePicker id="inv_due_date"
							className="input-field"
							format={DATE_FORMAT}
							style={{ width: "100%" }}
						/>
					</FormItem>
				</div>
				<div className="mb-6"> 
					<FormItem
		            	name="client_ids"
		                label="Client"
						rules={[requiredField()]}
		            >
		            	<Select 
							id="client_ids"
							mode="multiple"
							className="input-field"
		            		options={clientOptions}
							allowClear
							showSearch
							open={clientDropdownOpen}
  							onOpenChange={setClientDropdownOpen}
							onChange={handleClientChange}

		            	/>
	            	</FormItem>  
	 			</div>	
				<CrudButtons 
					baseRoute="/console/invoices" 
					mode="edit" 
					recordId={0} 
					submitLabel="Generate"
					moduleId={MODULE_INVOICES}
				/> 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
	recordList: state.optionlist.clientList?.items || [],
	forexList: state.optionlist.forexList?.items || [],
});

const mapDispatchToProps = (dispatch) => ({
	getClientOptions: (filters) => dispatch(getClientList(filters)),
	getForexOptions: (filters) => dispatch(getForexList(filters)),
	doGenerateInvoice: (data) => dispatch(doGenerateMonthlyInvoice(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyInvoiceForm);
